<template>
    <div class="preparation-pickup-point-production-order-delivery">
        <div class="row">
            <div class="col-lg-6 offset-lg-6 mb-3">
                <PreparationPickupPointProductionOrderDeliveryNote
                    :order="order"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import PreparationPickupPointProductionOrderDeliveryNote from "./PreparationPickupPointProductionOrderDeliveryNote"

    export default {
        name: 'PreparationPickupPointProductionOrderDelivery',

        components: {
            PreparationPickupPointProductionOrderDeliveryNote
        },

        props: {
            order: {
                type: Object,
                required: true,
            },
        },
    }
</script>
